import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

export const contactInfoNRO: NavigationRoutingObject = {
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("contact-information", "Contact Information"),
  pageNameForTracking: () => "Contact Information",
  getDeveloperNavigationAllowed: ({ hasPermission }) => {
    return hasPermission("company", {
      permission: "admin",
    });
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [
        t("contact-information-alt-keyword-1", "Manage Your Company Settings"),
        t("contact-information-alt-keyword-2", "Time Zone"),
        t("contact-information-alt-keyword-3", "Company Name"),
      ],
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
